import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7a2afc6d"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container-table" };
const _hoisted_2 = { class: "desktop-table" };
const _hoisted_3 = { class: "table-head" };
const _hoisted_4 = { class: "column1" };
const _hoisted_5 = { class: "column4" };
const _hoisted_6 = { class: "column2" };
const _hoisted_7 = { class: "column3" };
const _hoisted_8 = { class: "column2" };
const _hoisted_9 = { class: "column4" };
const _hoisted_10 = { class: "column5" };
const _hoisted_11 = { class: "column2" };
const _hoisted_12 = { class: "column6" };
const _hoisted_13 = { class: "column1 uppercase" };
const _hoisted_14 = { class: "column4" };
const _hoisted_15 = { class: "plan-twoword" };
const _hoisted_16 = { class: "column2" };
const _hoisted_17 = { class: "column3" };
const _hoisted_18 = { class: "column2" };
const _hoisted_19 = { class: "column4" };
const _hoisted_20 = { class: "column5" };
const _hoisted_21 = { class: "column2" };
const _hoisted_22 = {
    key: 0,
    class: "column6 status-green"
};
const _hoisted_23 = {
    key: 1,
    class: "column6 status-green"
};
const _hoisted_24 = {
    key: 2,
    class: "column6 status-blue"
};
const _hoisted_25 = {
    key: 3,
    class: "column6 status-red"
};
const _hoisted_26 = {
    key: 4,
    class: "column6 status-green"
};
const _hoisted_27 = { class: "mobile-table" };
const _hoisted_28 = { class: "table-head" };
const _hoisted_29 = { class: "column1" };
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_32 = { class: "column3" };
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_34 = { class: "column4" };
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_36 = { class: "column6" };
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_38 = { class: "column1" };
const _hoisted_39 = { class: "uppercase" };
const _hoisted_40 = /*#__PURE__*/ _createTextVNode();
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_42 = { class: "plan-twoword" };
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_44 = { class: "column3" };
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_46 = { class: "column4" };
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_48 = { class: "column6" };
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_50 = {
    key: 0,
    class: "status-green"
};
const _hoisted_51 = {
    key: 1,
    class: "status-green"
};
const _hoisted_52 = {
    key: 2,
    class: "status-blue"
};
const _hoisted_53 = {
    key: 3,
    class: "status-red"
};
const _hoisted_54 = {
    key: 4,
    class: "status-green"
};
import { useMessage } from '@/const/messages';
import dayjs from 'dayjs';
export default /*#__PURE__*/ _defineComponent({
    props: {
        columnName: null,
        data: null,
        isClickable: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const { STAKING_HISTORY, format } = useMessage();
        const FREE_PLAN = 1;
        const DATE_NOW = dayjs().format('YYYY-MM-DD 00:00:00');
        const checkStatus = (status) => {
            if (status === 'cancel')
                return true;
            if (status === 'complete')
                return true;
            return false;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("table", _hoisted_2, [
                    _createElementVNode("thead", null, [
                        _createElementVNode("tr", _hoisted_3, [
                            _createElementVNode("th", _hoisted_4, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).HEADER_SYMBOL)), 1),
                            _createElementVNode("th", _hoisted_5, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).HEADER_PERIOD)), 1),
                            _createElementVNode("th", _hoisted_6, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).HEADER_AMOUNT)), 1),
                            _createElementVNode("th", _hoisted_7, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).HEADER_EXPECTED)), 1),
                            _createElementVNode("th", _hoisted_8, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).HEADER_RESULT_AMOUNT)), 1),
                            _createElementVNode("th", _hoisted_9, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).HEADER_START)), 1),
                            _createElementVNode("th", _hoisted_10, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).HEADER_END)), 1),
                            _createElementVNode("th", _hoisted_11, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).HEADER_REMAINING)), 1),
                            _createElementVNode("th", _hoisted_12, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).HEADER_STATUS)), 1)
                        ])
                    ]),
                    _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (col) => {
                            return (_openBlock(), _createElementBlock("tr", {
                                key: col.symbolId
                            }, [
                                _createElementVNode("td", _hoisted_13, _toDisplayString(col.symbol), 1),
                                _createElementVNode("td", _hoisted_14, [
                                    _createElementVNode("span", _hoisted_15, _toDisplayString(col.lockinPeriod === FREE_PLAN
                                        ? _unref(format)(_unref(STAKING_HISTORY).FREE)
                                        : col.lockinPeriod + ' ' + _unref(format)(_unref(STAKING_HISTORY).DAY)), 1)
                                ]),
                                _createElementVNode("td", _hoisted_16, _toDisplayString(col.amount ? col.amount : '--'), 1),
                                _createElementVNode("td", _hoisted_17, _toDisplayString(col.expectedInterest ? col.expectedInterest : '--'), 1),
                                _createElementVNode("td", _hoisted_18, _toDisplayString(col.resultAmount ? col.resultAmount : '--'), 1),
                                _createElementVNode("td", _hoisted_19, _toDisplayString(col.startDate), 1),
                                _createElementVNode("td", _hoisted_20, _toDisplayString(col.endDate), 1),
                                _createElementVNode("td", _hoisted_21, _toDisplayString(col.remainingDays && col.status === 'staking' ? col.remainingDays : '--'), 1),
                                (_unref(dayjs)(_unref(DATE_NOW)) < _unref(dayjs)(col.startDate) && !checkStatus(col.status))
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).STATUS_APPLYING)), 1))
                                    : _createCommentVNode("", true),
                                (_unref(dayjs)(_unref(DATE_NOW)) >= _unref(dayjs)(col.startDate) &&
                                    _unref(dayjs)(_unref(DATE_NOW)) <= _unref(dayjs)(col.endDate) &&
                                    !checkStatus(col.status))
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).STATUS_STAKING)), 1))
                                    : _createCommentVNode("", true),
                                (_unref(dayjs)(_unref(DATE_NOW)) > _unref(dayjs)(col.endDate) && !checkStatus(col.status))
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_24, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).STATUS_MATURITY)), 1))
                                    : _createCommentVNode("", true),
                                (col.status === 'cancel')
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_25, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).STATUS_CANCEL)), 1))
                                    : _createCommentVNode("", true),
                                (col.status === 'complete')
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_26, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).STATUS_COMPLETE)), 1))
                                    : _createCommentVNode("", true)
                            ]));
                        }), 128))
                    ])
                ]),
                _createElementVNode("table", _hoisted_27, [
                    _createElementVNode("thead", null, [
                        _createElementVNode("tr", _hoisted_28, [
                            _createElementVNode("th", _hoisted_29, [
                                _createTextVNode(_toDisplayString(_unref(format)(_unref(STAKING_HISTORY).HEADER_SYMBOL)) + " ", 1),
                                _hoisted_30,
                                _createTextVNode(" " + _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).HEADER_PERIOD)) + " ", 1),
                                _hoisted_31,
                                _createTextVNode(" " + _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).HEADER_AMOUNT)), 1)
                            ]),
                            _createElementVNode("th", _hoisted_32, [
                                _createTextVNode(_toDisplayString(_unref(format)(_unref(STAKING_HISTORY).HEADER_EXPECTED)) + " ", 1),
                                _hoisted_33,
                                _createTextVNode(" " + _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).HEADER_RESULT_AMOUNT)), 1)
                            ]),
                            _createElementVNode("th", _hoisted_34, [
                                _createTextVNode(_toDisplayString(_unref(format)(_unref(STAKING_HISTORY).HEADER_START)) + " ", 1),
                                _hoisted_35,
                                _createTextVNode(" " + _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).HEADER_END)), 1)
                            ]),
                            _createElementVNode("th", _hoisted_36, [
                                _createTextVNode(_toDisplayString(_unref(format)(_unref(STAKING_HISTORY).HEADER_REMAINING)) + " ", 1),
                                _hoisted_37,
                                _createTextVNode(" " + _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).HEADER_STATUS)), 1)
                            ])
                        ])
                    ]),
                    _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (col) => {
                            return (_openBlock(), _createElementBlock("tr", {
                                key: col.symbolId
                            }, [
                                _createElementVNode("td", _hoisted_38, [
                                    _createElementVNode("span", _hoisted_39, _toDisplayString(col.symbol), 1),
                                    _hoisted_40,
                                    _hoisted_41,
                                    _createElementVNode("span", _hoisted_42, _toDisplayString(col.lockinPeriod === FREE_PLAN
                                        ? _unref(format)(_unref(STAKING_HISTORY).FREE)
                                        : col.lockinPeriod + ' ' + _unref(format)(_unref(STAKING_HISTORY).DAY)), 1),
                                    _hoisted_43,
                                    _createTextVNode(" " + _toDisplayString(col.amount ? col.amount : '--'), 1)
                                ]),
                                _createElementVNode("td", _hoisted_44, [
                                    _createTextVNode(_toDisplayString(col.expectedInterest ? col.expectedInterest : '--') + " ", 1),
                                    _hoisted_45,
                                    _createTextVNode(" " + _toDisplayString(col.resultAmount ? col.resultAmount : '--'), 1)
                                ]),
                                _createElementVNode("td", _hoisted_46, [
                                    _createTextVNode(_toDisplayString(col.startDate) + " ", 1),
                                    _hoisted_47,
                                    _createTextVNode(" " + _toDisplayString(col.endDate), 1)
                                ]),
                                _createElementVNode("td", _hoisted_48, [
                                    _createTextVNode(_toDisplayString(col.remainingDays && col.status === 'staking' ? col.remainingDays : '--') + " ", 1),
                                    _hoisted_49,
                                    (_unref(dayjs)(_unref(DATE_NOW)) < _unref(dayjs)(col.startDate) && !checkStatus(col.status))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).STATUS_APPLYING)), 1))
                                        : _createCommentVNode("", true),
                                    (_unref(dayjs)(_unref(DATE_NOW)) >= _unref(dayjs)(col.startDate) &&
                                        _unref(dayjs)(_unref(DATE_NOW)) <= _unref(dayjs)(col.endDate) &&
                                        !checkStatus(col.status))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).STATUS_STAKING)), 1))
                                        : _createCommentVNode("", true),
                                    (_unref(dayjs)(_unref(DATE_NOW)) > _unref(dayjs)(col.endDate) && !checkStatus(col.status))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).STATUS_MATURITY)), 1))
                                        : _createCommentVNode("", true),
                                    (col.status === 'cancel')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).STATUS_CANCEL)), 1))
                                        : _createCommentVNode("", true),
                                    (col.status === 'complete')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(_unref(format)(_unref(STAKING_HISTORY).STATUS_COMPLETE)), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ]));
                        }), 128))
                    ])
                ])
            ]));
        };
    }
});
